import { Image } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Person, PersonCard } from '@carbonify/ui';
import CtaButton from 'components/CtaButton';
import { ResponsiveImage } from 'services/graphql';

interface PersonBlockRecord extends CdaStructuredTextRecord {
  image?: ResponsiveImage;
  title: string;
  subtitle?: string;
  cta?: string;
  variant?: 'card' | 'inline';
}

export default function PersonBlock({ title, subtitle, image, cta, variant = 'card' }: PersonBlockRecord) {
  const Tag = variant === 'inline' ? Person : PersonCard;

  return (
    <Tag
      // eslint-disable-next-line jsx-a11y/alt-text
      image={image && <Image data={image.responsiveImage} />}
      title={title}
      subtitle={subtitle}
      cta={
        <CtaButton
          variant="ghost"
          size="sm"
        >
          {cta}
        </CtaButton>
      }
    />
  );
}
